import { FontWeight, Heading, LiliSwitch, LiliSwitchSize } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ColoredUnderline } from '../../../assets/icons/svg/colored-icons/ic-colored-underline.svg';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { planReportName } from '../service';

interface PlansAnnualSwitcherProps {
  isAnnual: boolean;
  setIsAnnual: (isAnnual: boolean) => void;
  discountPercentage: number;
  currentPlan: string;
}

const PlansAnnualSwitcher = (props: PlansAnnualSwitcherProps) => {
  const { t } = useTranslation();
  const { isAnnual, setIsAnnual, discountPercentage, currentPlan } = props;

  const handleSwitcherChange = () => {
    const newValue = !isAnnual;
    trackMixPanel('Act on Lili Plans Full Offer Screen', {
      Action: 'Switched to annual',
      'Current Plan': planReportName(currentPlan),
      Annual: newValue,
    });
    setIsAnnual(newValue);
  };

  return (
    <div className='flex items-center'>
      <div className='inline-block relative'>
        <Heading.H10 fontWeight={FontWeight.SEMIBOLD} className='text-action03'>
          {t('PLAN_UPGRADE.PLAN_PICKER.SWITCHER_EXTRA_20', { discountPercentage })}
        </Heading.H10>
        <ColoredUnderline className='absolute top-[14px] -left-[2px] w-full' />
      </div>
      <Heading.H10 className='mr-[8px] ml-[3px]'>{t('PLAN_UPGRADE.PLAN_PICKER.DISCOUNT_WITH')}</Heading.H10>
      <div className='flex rounded-[4px] border-[1px] border-outline-primary-bw-03 bg-surface-primary-bw-01 px-[10px] py-[6px] gap-[4px] items-center'>
        <LiliSwitch
          id='annual-switch'
          size={LiliSwitchSize.MEDIUM}
          checked={isAnnual}
          onChange={handleSwitcherChange}
        />
        <Heading.H10>{t('PLAN_UPGRADE.PLAN_PICKER.ANNUAL_SUB')}</Heading.H10>
      </div>
    </div>
  );
};

export default PlansAnnualSwitcher;
